import { canApproveHours, canDenyHours } from '../../../../../backend/utils/shiftStateUtils';
import { approveHoursDialog } from '../../../../../ui/features/shift-roster-table/utils/approveHoursDialog';
import { denyHoursDialog } from '../../../../../ui/features/shift-roster-table/utils/denyHoursDialog';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button } from '@mui/material';
import React from 'react';
export const ParticipantShiftsTableRowActions = ({ row, fetchReload, handleDenyHours, handleApproveHours }) => {
    const { t } = useMissionsTranslation();
    const showDeny = canDenyHours(row);
    const showApprove = canApproveHours(row);
    return (React.createElement(Box, { sx: {
            display: 'flex',
            gap: 1,
            flexDirection: { xs: 'column', lg: 'row' },
            justifyContent: 'end',
        } },
        showDeny && (React.createElement(Button, { startIcon: React.createElement(CloseIcon, null), onClick: (event) => {
                event.stopPropagation();
                denyHoursDialog({
                    row,
                    handleDenyHours,
                    fetchReload,
                    t,
                });
            }, "data-test": 'deny', variant: 'outlined', size: 'small' }, t('timeTracking.denyButtonLabel'))),
        showApprove && (React.createElement(Button, { startIcon: React.createElement(CheckIcon, null), onClick: (event) => {
                event.stopPropagation();
                approveHoursDialog({
                    rows: [row],
                    fetchReload,
                    t,
                    handleApproveHours,
                });
            }, variant: 'contained', size: 'small', "data-test": 'approve-hours' }, t('shifts.adminTimeTracking.approveHours')))));
};
